export const teacherOrAdminLoggedAndIsAuthor = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "delete",
  },
  {
    key: "2",
    labelPT: "Fechar tópico",
    labelEN: "Close topic",
    icon: "bi-check2-square",
    method: "closeTopic",
  },
  {
    key: "3",
    labelPT: "Editar",
    labelEN: "Edit",
    icon: "md-edit-outlined",
    method: "edit",
  },
];

export const teatcherOrAdminLoggedAndIsNotAuthor = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "delete",
  },
  {
    key: "2",
    labelPT: "Fechar tópico",
    labelEN: "Close topic",
    icon: "bi-check2-square",
    method: "closeTopic",
  },
];

export const teacherOrAdminLoggedAndTopicClosed = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "delete",
  },
  {
    key: "2",
    labelPT: "Abrir tópico",
    labelEN: "Close topic",
    icon: "bi-check2-square",
    method: "openTopic",
  },
];

export const teacherOrAdminLoggedButTopicIsSolved = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "delete",
  },
];

export const studentLoggedAndIsAuthor = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "delete",
  },
  {
    key: "2",
    labelPT: "Fechar tópico",
    labelEN: "Close topic",
    icon: "bi-check2-square",
    method: "closeTopic",
  },
  {
    key: "3",
    labelPT: "Editar",
    labelEN: "Edit",
    icon: "md-edit-outlined",
    method: "edit",
  },
];

export const studentLoggedAndIsNotAuthor = [
  {
    key: "1",
    labelPT: "Denunciar",
    labelEN: "Report",
    icon: "md-outlinedflag-round",
    method: "report",
  },
];

export const studentLoggedAndIsAuthorButTopicIsClosed = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "delete",
  },
];

export interface topicOptions  {
  key: string
  labelPT: string
  labelEN: string
  icon: string
  method: string
}